<script setup lang="ts">
import { TheAlertDisplayer, TheDialogDisplayer } from "@debitroom-software/vuetify-alert";
import { TheSnackbarQueue } from "@debitroom-software/vuetify-snackbar-queue";
import { useRoute, useRouter } from "vue-router";

import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";
import useAppUrlOpen from "@/shared/composables/useAppUrlOpen";

useAppUrlOpen();

// App.addListener("appStateChange", ({ isActive }: any) => {
//   // console.log("App state changed. Is active?", isActive);
// });
//
//
// App.addListener("appRestoredResult", (data: any) => {
//   // console.log("Restored state:", data);
// });

const router = useRouter();
const route = useRoute();
const authorisationStore = useAuthorisationStore();

router.isReady().then(() => {
  if (!authorisationStore.redirectToAfterLoginUrl) {
    authorisationStore.redirectToAfterLoginUrl = route.fullPath;
  }
});
</script>

<template>
  <router-view />
  <TheSnackbarQueue />
  <TheAlertDisplayer />
  <TheDialogDisplayer />
</template>
